import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { ActingQueryData } from '@area-restrita/api-client/model/actingQueryData';

import ChecklistBadge from '@/components/ChecklistBadge';

type IProps = CellContext<ActingQueryData, unknown>;

const ChecklistCell: React.FC<IProps> = ({ row }) => (
  <ChecklistBadge label={row.original.usedChecklist?.name ?? 'N/A'} />
);

export default ChecklistCell;
